export const INBOX_PAGE_SIZE = 30

// How often the bell asks for fresh counts while the dashboard is open
export const INBOX_POLL_MS = 60_000
